// extracted by mini-css-extract-plugin
export default {"beat":"Beat_beat__DvvTQ"};